<template>
  <div>
    <label :for="id">
      <input type="checkbox" :id="id" v-model="checkbox" v-bind="$attrs">
      <CheckboxSvg :state="checkbox"/>
      <slot></slot>
    </label>
  </div>
</template>

<script>
import CheckboxSvg from "@/components/icons/CheckboxSvg";

export default {
  name: "InputCheckbox",
  components: {CheckboxSvg},
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      checkbox: '',
    }
  },
  watch: {
    checkbox(val) {
      this.$emit('update:value', val)
    },
    value(val) {
      this.checkbox = val
    },
  },
  beforeMount() {
    this.checkbox = this.value
  },
}
</script>

<style scoped lang="scss">
label {
  cursor: pointer;

  [type="checkbox"] {
    height: 0;
    width: 0;
    opacity: 0;
    display: none;
  }
}
</style>
